<template>
  <div>
    <BModal
      id="modal-pin"
      ref="modal-pin"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      hide-footer
      hide-header
      centered
    >
      <BCol class="flex justify-center mt-2">
        <h4 class="text-black font-semibold">
          Masukan PIN
        </h4>
      </BCol>

      <BCol class="flex text-center justify-center mt-1">
        <small>
          <strong>Mohon verifikasi identitas Kamu dengan memasukkan PIN.
            <br>
            <span
              style="color: #f95031"
              class="cursor-pointer"
              @click="$router.push({ name: 'pin' })"
            >
              Lupa PIN?
            </span>
          </strong>
        </small>
      </BCol>

      <BCol class="flex justify-center mt-2 mb-1">
        <CodeInput
          style="-webkit-text-security: disc"
          :loading="loading"
          class="input"
          @change="onChange"
        />
      </BCol>

      <BCol class="flex justify-center my-2">
        <BButton
          variant="outline-primary"
          class="mr-1"
          @click="closeModal"
        >
          Kembali
        </BButton>
        <BButton
          :variant="pin === null || pin.length < 6 ? 'secondary' : 'primary'"
          :disabled="pin === null || pin.length < 6"
          @click="onFinish"
        >
          <BSpinner
            v-if="loading"
            variant="light"
            small
          />
          Konfirmasi
        </BButton>
      </BCol>
    </BModal>
    <modal-max-pin />
  </div>
</template>

<script>
import {
  BModal, BCol, BButton, BSpinner,
} from 'bootstrap-vue'
import CodeInput from 'vue-verification-code-input'
import { newAxiosIns } from '@/libs/axios'
import { CONFIRM_PIN } from '@/provider/url'
import ToastificationContentVue from '@/@core/components/toastification/ToastificationContent.vue'
import ModalMaxPin from '@/views/components/modal/ModalMaxPin.vue'

export default {
  components: {
    BModal, BCol, BButton, BSpinner, CodeInput, ModalMaxPin,
  },
  data() {
    return {
      pin: '',
      userId: this?.$store?.state?.auth?.userData?.id,
      loading: false,
    }
  },
  methods: {
    async onFinish() {
      this.loading = true
      try {
        const res = await newAxiosIns.post(CONFIRM_PIN, { pin: this.pin })
        const { data } = res.data
        if (data?.is_valid) {
          this.$bvModal.hide('modal-pin')
          this.$emit('fromChild')
        } else {
          this.showPinError(data)
        }
      } catch (err) {
        console.log('message:', err.message, '| response:', err.response)
        const body = err?.response?.data
        const data = body?.data
        if (typeof data === 'string' && data.includes('maximum pin attempt')) {
          this.handleLocked()
        } else {
          this.showPinError(data)
        }
      } finally {
        this.loading = false
      }
    },
    showPinError(data) {
      const left = data?.attempt_left
      this.$toast({
        component: ToastificationContentVue,
        props: {
          title: 'Gagal',
          icon: 'AlertCircleIcon',
          text: left !== undefined
            ? `PIN yang anda masukkan salah. Sisa percobaan: ${left}`
            : 'PIN yang anda masukkan salah',
          variant: 'danger',
        },
      }, 2000)
    },
    handleLocked() {
      this.$bvModal.hide('modal-pin')
      this.$bvModal.show('max-chance-PIN')
    },
    onChange(value) {
      this.pin = value
    },
    closeModal() {
      this.$emit('onClose')
    },
  },
}
</script>

<style>

</style>
